import { TExportEventType } from "constants/index";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useCallback, useRef } from "react";
import { MUTATION_AUDIT_LOG } from "services/graphQL/mutations";

function useAuditEventLog(gqlClientForProject: any) {
  const [logAuditEvent] = useCIQMutation(
    MUTATION_AUDIT_LOG,
    gqlClientForProject ? { client: gqlClientForProject } : {}
  );
  const logAuditEventRef = useRef(logAuditEvent);
  logAuditEventRef.current = logAuditEvent;

  const saveAuditLogEvent = useCallback(
    async (eventData: {
      eventType: TExportEventType;
      featureType: string | null;
      filename: string;
      attachmentId?: string;
    }) => {
      if (!gqlClientForProject) {
        return { success: false };
      }

      // Audit logging is fire-and-forget: a failure must never surface a
      // toast to the user (it is still reported to Sentry by ErrorManager).
      const res = await logAuditEventRef.current(
        {
          variables: {
            eventData: {
              eventType: eventData.eventType,
              featureType: eventData.featureType,
              ...(eventData.attachmentId
                ? { attachmentId: eventData.attachmentId }
                : {}),
              metadata: {
                filename: eventData.filename
              }
            }
          }
        },
        { showError: false }
      );
      if (!res?.success) {
        return { success: false, error: res?.error };
      }
      return { success: true, data: res?.data };
    },
    [gqlClientForProject]
  );

  return { saveAuditLogEvent };
}

export default useAuditEventLog;
